const $cart = $('.js-cart');

export default {
  initialize() {
    this.createListeners();
  },

  createListeners() {
    $cart.on('change', '.js-cart-item-quantity', this.handleQuantityChange.bind(this));
    $cart.on('click', '.js-cart-item-delete', this.handleItemDelete.bind(this));
  },

  handleQuantityChange(e) {
    const $input = $(e.currentTarget);
    const quantity = parseInt($input.val(), 10);
    const cartItemId = this.getCartItemId(this.retrieveCartItem($input));

    if (Number.isNaN(quantity)) {
      return;
    }

    this.updateCartItem(cartItemId, quantity);
  },

  handleItemDelete(e) {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const $cartItem = this.retrieveCartItem($button);
    const cartItemId = this.getCartItemId($cartItem);

    this.deleteCartItem(cartItemId)
      .then(() => {
        $cartItem.remove();
      });
  },

  /**
   * @param {object} $el
   * @returns {object}
   */
  retrieveCartItem($el) {
    return $el.parents('.js-cart-item');
  },

  /**
   * @param {object} $row
   * @returns {int}
   */
  getCartItemId($row) {
    return parseInt($row.data('id'), 10);
  },

  /**
   * @param {int} cartItemId
   * @param {int} quantity
   * @returns {Promise}
   */
  updateCartItem(cartItemId, quantity) {
    return $.post(window.app.api.cartItemUpdate.replace(':id', cartItemId), {
      _method: 'PUT',
      quantity,
    });
  },

  /**
   * @param {int} cartItemId
   * @returns {Promise}
   */
  deleteCartItem(cartItemId) {
    return $.post(window.app.api.cartItemDestroy.replace(':id', cartItemId), {
      _method: 'DELETE',
    });
  },
};
